import axios from 'axios'
import store from 'store'
// import { notification } from 'antd'
import * as qs from "qs";
import {API_URL} from "config/global";
import {getApiBaseUrl} from "config/tenantRouting";
import keycloak from "config/keycloak";
import {responseInterceptor} from 'dev/axiosInterceptors'
import { getCurrentAccount } from '../accountService'
import { installaDiagnostica, registraAxios } from '../diagnostica'

const apiClient = axios.create({
  baseURL: API_URL,
  // timeout: 1000,
  // headers: { 'accept': 'application/json' }
})

window.addEventListener('storage', (event) => {
  if (event.key === 'currentAccountId') {
    document.location.reload();
  }
});

apiClient.interceptors.request.use(async request => {
  let accessToken

  // canary routing: relative urls resolve against the active tenant's API
  request.baseURL = getApiBaseUrl() || request.baseURL

  const queryUrl = qs.parse(document.location.hash.split("?")?.[1] , { ignoreQueryPrefix: true }) || {}

  if(queryUrl?.token){
    request.headers['X-Auth-Token'] = `${queryUrl?.token}`
  }else{
    // keycloak refresh token
    try {
      // await keycloak.init({onLoad: 'login-required', responseMode: 'check-sso'})
      const refreshed = await keycloak.updateToken(5)
      if(refreshed){
        accessToken = keycloak.token
        store.set('accessToken', accessToken)
      } else {
        accessToken = store.get('accessToken')
      }
      // console.log("refreshed")
    }catch (e) {
      // console.log("error refreshed")
      // return keycloak.init({onLoad: 'login-required', responseMode: 'query'})
    }
    if (accessToken) {
      const currentAccountId = getCurrentAccount()
      if(currentAccountId){
        accessToken = `${accessToken}#${currentAccountId}`
      }
      request.headers.Authorization = `Bearer ${accessToken}`
      // request.headers.AccessToken = accessToken
    }
  }

  if (process.env.NODE_ENV === 'development' && document.cookie.indexOf('XDEBUG_SESSION=PHPSTORM') >= 0) {
    request.params = request.params || {}
    request.params.XDEBUG_SESSION_START='PHPSTORM'
  }


  if(request.method === "patch" && !request.headers?.['Content-Type']){
    request.headers['Content-Type'] = 'application/merge-patch+json'
  }

  return request
})

apiClient.interceptors.request.use(config => {
  config.paramsSerializer = params2 =>
    qs.stringify(params2, {
      arrayFormat: 'indices',
      encode: false,
      skipNulls: true,
      // strictNullHandling: true
    })
  return config
})

if(process.env.NODE_ENV === 'development'){
  apiClient.interceptors.response.use(responseInterceptor)
}

// Informazioni tecniche per le richieste di assistenza (solo in memoria, vedi services/diagnostica)
installaDiagnostica()
registraAxios(apiClient)

/* apiClient.interceptors.response.use(undefined, error => {
  // Errors handling
  const { response } = error
  const { data } = response
  if (data) {
    notification.warning({
      message: `Errore ${response.status}`,
    })
  }
}) */

export const ITEM_CODES_TYPES = {
  projectStatus: "stato_progetto",
  candidatureStatus: "stato_cv_prog",
  answerAdStatus: "stato_risposta",
  candidateStatus: "stato_candidato",
  projectCandidateStatus: "stato_cv_prog",
  projectSeniority: "seniority",
  projectRefusedReason: "progetto_rifiutato",
}

export default apiClient
